import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=6778b2ba&scoped=true&"
import script from "./editForm.vue?vue&type=script&lang=ts&"
export * from "./editForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778b2ba",
  null
  
)

export default component.exports